import React, { memo } from 'react';
import { useTranslate } from 'react-polyglot';

const DeactivateExp = memo(function DeactivateExp(props) {
    const t = useTranslate();
    const translationKey = props.data.isActive ? 'deactivateExp' : 'activateExp';

    return (
        <div>
            <p className='coa-dialog-msg'>{t(`experiences.${translationKey}.msg`)}</p>
            <p className='coa-dialog-msg-body'>{t(`experiences.${translationKey}.msgBody`)}</p>
        </div>
    )
})


export default DeactivateExp
